import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Backdrop, Box, CircularProgress, Container, Paper, Typography } from "@mui/material";

import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import SkillInfoForm from "../../components/skillInfo/SkillInfoForm";
import FormContent, {
  buildSkillPayload,
  recordToFormValues,
} from "../../components/skillInfo/skillInfoFormSchema";
import { getDataRequest, postDataRequest } from "../../helper/AxiosHelper";

export default function Component() {
  const { skillId } = useParams();
  const navigate = useNavigate();
  const formik = useFormik(FormContent.FormikInstance);
  const [rankSeed, setRankSeed] = useState(null);
  const [record, setRecord] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    getDataRequest(`skillInfo/show/${skillId}`, (isSuccess, data) => {
      if (!isSuccess || !data?.record) {
        toast.error("找不到技能資料");
        setIsLoading(false);
        return;
      }
      const nextValues = recordToFormValues(data.record);
      formik.setValues(nextValues);
      setRankSeed({
        rank_direction: nextValues.rank_direction,
        skill_rank_male: nextValues.skill_rank_male,
        skill_rank_female: nextValues.skill_rank_female,
      });
      setRecord(data.record);
      setIsLoading(false);
    });
  }, [skillId]);

  const handleUpdate = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched(
        Object.keys(errors).reduce((touched, key) => ({ ...touched, [key]: true }), {})
      );
      toast.error("請檢查表單");
      return;
    }

    let payload;
    try {
      payload = buildSkillPayload(formik.values);
    } catch (error) {
      toast.error("輸入設定必須是 JSON");
      return;
    }

    postDataRequest(`skillInfo/update/${skillId}`, payload, (isSuccess, message) => {
      if (!isSuccess) {
        toast.error(typeof message === "string" && message ? message : "更新失敗");
        return;
      }
      toast.success("更新成功");
      setTimeout(() => navigate("/skill_infos"), 800);
    });
  };

  return (
    <Container maxWidth={"lg"}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CommonBreadcrumb dbData={record} />
      <Box sx={{ mt: 3 }}>
        <Paper sx={{ px: 3, py: 5 }} elevation={3}>
          {record ? (
            <Typography variant="h5" sx={{ mb: 2 }}>
              {record.name_zh || record.name_en}
            </Typography>
          ) : null}
          {rankSeed ? (
            <SkillInfoForm
              formik={formik}
              rankSeed={rankSeed}
              onSubmit={handleUpdate}
              submitLabel="更新"
            />
          ) : null}
        </Paper>
      </Box>
    </Container>
  );
}
